import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=b1466ef0&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"
import style0 from "./Faq.vue?vue&type=style&index=0&id=b1466ef0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1466ef0')) {
      api.createRecord('b1466ef0', component.options)
    } else {
      api.reload('b1466ef0', component.options)
    }
    module.hot.accept("./Faq.vue?vue&type=template&id=b1466ef0&", function () {
      api.rerender('b1466ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/faq/Faq.vue"
export default component.exports